import { ProductCategory, ShoppingPlatform } from './enums';

// Props types (data passed to components)
export interface Product {
  id: string;
  name: string;
  image: string;
  size: string;
  price: Price;
  category: ProductCategory;
  description?: string;
  shoppingPlatforms?: ShoppingPlatformItem[];
  promotions?: Promotion[];
}

export interface Price {
  amount: string;
  currency: string;
}

export interface ShoppingPlatformItem {
  id: string;
  name: string;
  platform: ShoppingPlatform;
  logo: string;
  url: string;
}

export interface ProductsPageProps {
  heroProducts: Product[];
  products: Product[];
  shoppingPlatforms: ShoppingPlatformItem[];
}

export interface Promotion {
  id: string;
  image: string;
  url: string;
}

export interface PromotionItem {
  id: string;
  title: string;
  image: string;
  content: string;
}

export interface Banner {
  id: string;
  image: string;
  url: string;
}

export interface Certification {
  image: string;
  title: string;
  documentImage: string;
}

export interface Review {
  reviewType: ReviewType;
  review: string;
  author?: string;
  authorImage?: string;
}

export enum ReviewType {
  VIDEO = "video",
  IMAGE = "image",
  TEXT = "text",
}

// Recommended Menus interfaces
export interface RecommendedMenu {
  id: number;
  imageCover: string;
  name: string;
  image: string[];
  Description: string;
  process: string[];
  galleryImages: string[];
}

// News & Events interfaces
export interface NewsItem {
  id: number;
  title: string;
  description: string;
  imageUrl: string;
  publishDate?: string;
  content?: string;
  galleryImages?: string[];
}

// Contact form data types
export interface ContactFormData {
  fullName: string;
  phone: string;
  email: string;
  country: string;
  subject: string;
  message: string;
}

export interface OfficeLocation {
  id: string;
  title: string;
  address: string;
  phone: string[];
  latitude: number;
  longitude: number;
}

export interface CountryOption {
  value: string;
  label: string;
}

// Props types
export interface ContactSectionProps {
  officeLocations?: OfficeLocation[];
  countryOptions?: CountryOption[];
  onSubmitForm?: (data: ContactFormData) => void;
}